module.exports = __webpack_public_path__ + "static/about-insta-11@2x-7988dfd498d3dd5106ed563fd4fafb93.jpg";